import moment from 'moment'
export default {
    name: 'visites-medicales',
    components: {},
    props: [],
    data() {
        return {
            groupcheckBoxClicked: false,
            word_filter: null,
            editable_headers: [],
            editable_rows: [],
            filter_poste: null,
            filter_departement: null,
            
            


            list_programmation_is_empty: false
        }
    },
    watch: {
        programmations(){
            this.editable_headers = this.programmations.headers
            this.editable_rows = this.programmations.rows
        },
        word_filter(){
            this.filterProgrammations()
        },
        filter_poste(){
            this.filterProgrammations()
        }
    },
    
    computed: {
        year(){
            moment(this.latestVisiteEnCours.date_debut).year()
        },
        postes(){
            return this.$store.getters["postes"]
        },
        departements() {
            return this.$store.getters['departements']
        },
        latestVisiteEnCours(){
            return this.$store.getters["latestVisiteMedicaleAnnuelle"]
        },
        stats() {
            return this.$store.getters["latestVisiteStats"]
        },

        programmations() {
            return this.$store.getters["currentProgrammationLists"]
        },
        

    },
    mounted() {
        this.$store.dispatch("getPostes",this.$route.params.id)
        this.$store.dispatch("getDepartements")
        this.editable_headers = this.programmations.headers
        this.editable_rows = this.programmations.rows

        if (this.programmations.rows.length > 0) {
            this.list_programmation_is_empty = false
        } else {
            this.list_programmation_is_empty = true
        }

        console.log("PP: ", this.programmations)
    },
    methods: {
        shortenString(value, s_len) {
            let shorten_string = value
            let len = value.length

            if (len > s_len) {
                shorten_string = value.substr(0, s_len)+'...'
            }

            return shorten_string
        },

        checkIfTooLong(value, s_len) {
            let len = value.length
             let is_too_long = false
            if (len > s_len) {
                is_too_long = true
            }

            return is_too_long
        },

        selectAGroupForEmployees: function(groupe_id,state){
            let programmationsChecked = []

            this.editable_rows.forEach(element => {
                element.parametres.forEach(parametre =>{
                    if(parametre.groupe_id === groupe_id && this.groupcheckBoxClicked === true){
                        parametre.is_selected = state
                        programmationsChecked.push(parametre.programmation_id)
                    }
                } )
            });

            let data = {
                groupe_id: groupe_id,
                state: state,
                programmations:programmationsChecked
            }

            this.$store.dispatch("checkGroupeForEmployees",{id:this.latestVisiteEnCours.id,data:data})
        },
        selectAGroupForEmployee: function(programmation){
            let programmationsChecked = []
            programmationsChecked.push(programmation.programmation_id)

            let data = {
                groupe_id: programmation.groupe_id,
                state: programmation.is_selected,
                programmations: programmationsChecked
            }                                                     

            console.log(data)

            this.$store.dispatch("checkGroupeForEmployees",{id:this.latestVisiteEnCours.id,data:data})

            
        },
        selectASingleProgrammation: function(){
            console.log("bb")
        }, 
        filterProgrammations:function(){
            let departement_id = ""
            let word_filter = ""
            let poste = ""
            if(this.filter_departement ==null){
                 departement_id = ""
            }else{
                departement_id = this.filter_departement.id
            }
            if(this.word_filter == null){
                word_filter = ""
            }else {
                word_filter = this.word_filter
            }
            if(this.filter_poste == null){
                poste = ""
            }else {
                poste = this.filter_poste.poste
            }

            this.$store.dispatch("searchProgrammationsVisitesMedicales",{visite_id: this.latestVisiteEnCours.id,word_filter:word_filter,departement_id:departement_id,poste})
        },
        theCheckboxIsClicked: function(){
            this.groupcheckBoxClicked = true
        },
        singleProgCheckboxIsClicked: function(groupe_id){
            this.groupcheckBoxClicked = false

           this.editable_headers.forEach(
               element => {
                   if(element.groupe_id === groupe_id){
                       element.state = false
                   }

               }
           )
        }

    }
}


